import './TableData.scss';
import React, { useEffect, useState } from 'react';
import { IDocumentTable } from '@models/Forms/IForms';
import { isVisibleRowButton } from '@utils/tableHelper';
import clsx from 'clsx';
import Tooltip from '@atoms/Tooltip';

export interface RowDeleteButtonProps {
    table: IDocumentTable;
    rowData: any;
    onDelete: (rowData: any) => void;
    docId?: string;
}

const RowDeleteButton: React.FC<RowDeleteButtonProps> = ({ table, rowData, onDelete, docId }: RowDeleteButtonProps) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        isVisibleRowButton(table.singleRowDeleteButtonRules, rowData).then((value) => {
            setIsVisible(value);
        });
    }, []);

    const onClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete(rowData);
    };

    return isVisible ? (
        <button
            type="button"
            className={clsx(
                'form-table-button',
                'form-table-button__delete',
                'dx-link',
                'dx-link-delete',
                'dx-icon-trash',
                'dx-link-icon',
            )}
            onClick={onClick}
            title="Удалить строку"
            aria-label="Удалить строку"
        />
    ) : table.singleRowDeleteButtonDisabledTitle ? (
        <Tooltip openDelay={100} background="black" position="top">
            <button
                type="button"
                className={clsx(
                    'form-table-button',
                    'form-table-button__delete',
                    'dx-link',
                    'dx-link-delete',
                    'dx-icon-trash',
                    'dx-link-icon',
                    'dx-state-disabled',
                )}
            />
            {table.singleRowDeleteButtonDisabledTitle}
        </Tooltip>
    ) : null;
};

export default RowDeleteButton;
